
<template>
  <div class="login">

    <!-- —————————— HEADER —————————— -->
    <header class="container-fluid text-center">
      <div class="row">
        <div id="logo" class="col-12 pt-5 pb-4">
          <img class="logo" src="/SIMmersion_logo-white.svg" width="162" ref="SIMmersion Logo">
        </div>
      </div>
    </header>
    <!-- —————————— END HEADER —————————— -->

    <div id="login" class="container">
      <template>
        <div id="banner" v-if="bannerMessage">
          <marquee behavior="scroll" direction="left" id="bannerMessage">
            {{ bannerMessage }}
          </marquee>
        </div>
      </template>
      <div class="row">
        <div class="col-12">
          <h1 class="loginPage text-center mb-4">Administrative Center</h1>
        </div>
        <div class="col-12 col-md-8 col-lg-6 ml-auto mr-auto">
          <div class="loginBox bg-white rounded mt-1 mb-1">

            <p class="errorBox" v-show="errorMsg!==null" v-html="errorMsg"></p>

            <div class="row">
              <div class="col-4">
                <h2 class="loginPage mb-5 mt-0">
                  Log In
                </h2>
              </div>
              <div class="col-8 text-right">
                <button class="btn btn-secondary" @click="doOrgLogin">Use My Organization&rsquo;s Login</button>
              </div>
            </div>

            <p class="label text-dark mb-2">
              Email Address or Username:
            </p>
            <input type="text" class="fullWidth" id="logineml" v-model="email">

            <p class="label text-dark mb-2">
              Password:
            </p>

            <input type="password" class="fullWidth" id="loginpasswrd" v-model="pass" @keyup="checkKeyup">

            <p class="remember-creds mb-4">
              <input type="checkbox" id="rememberme" v-model="remember"> Remember My Credentials
            </p>
            <div class="row">
              <div class="col-8 text-left">
                <b-button v-b-modal.forgotPassword>Forgot Password?</b-button>
              </div>
              <div class="col-4 text-right">
                <button class="btn btn-primary btn-login" @click="doLoginForm">Login</button>
              </div>

            </div>
          </div>
        </div>
        <div class="col-12 text-center">
          <ul class="login-nav mt-4 p-0">
            <li class="d-inline-block ml-2 mr-2"><a class="text-white u" href="https://training.simmersion.com" target="_blank">Training Center</a></li>
            <li class="d-inline-block ml-2 mr-2"><a class="text-white u" href="http://www.simmersion.com/" target="_blank">SIMmersion.com</a></li>
            <li class="d-inline-block ml-2 mr-2"><a class="text-white u" href="https://www.simmersion.com/contact" target="_blank">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div id="login-footer" class="container-fluid pb-5 pt-4">
      <div class="row">
        <div class="col-12 text-center">
          <p class="m-0 text-white opacity-dim"><small id="dateLine">&copy; 2020 SIMmersion&trade;</small></p>
        </div>
      </div>
    </div>

    <b-modal ref="orgModal" title="Organization Login" @ok="doOrgLoginOK">
      <div class="row">
        <div class="col-12">
          <b>Organization Credential</b><br />
          <input type="text" v-model="orgcredential" class="fullWidth" /><br />
          (You will be redirected to your organization to log in)
        </div>
      </div>
    </b-modal>

    <b-modal id="forgotPassword" ok-only title="Forgot Your Password?">
      <p class="my-4">To reset your password visit https://training.simmersion.com and click 'Forgot Your Password'</p>
    </b-modal>

  </div>


</template>

<style scoped>

  h1.loginPage {
    color: #FFF;
    font-size: 26px;
    margin-top: 80px;
  }

  h2.loginPage {
    font-size: 22px;
  }

  div.loginBox {
    padding: 35px 40px 30px 40px;
  }

  .btn-login {
    max-width: 160px !important;
  }

  div.loginBox .label, label {
    padding: 0 !important;
    margin-bottom: 10px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    display: block;
    text-align: left !important;
  }

  .errorBox {
    font-weight: normal !important;
  }

  #banner {
    background-color: #f3b70c;
    color: #000;
    padding: 1em;
    text-align: center;
  }
</style>

<script language="javascript">


  var PortalID = "";
  var portalURL = "";
  var UMichPoolID = "";
  if (window.location.origin.indexOf("admin.simmersion.com") > -1) {
    PortalID = "7728DEAD-2980-4748-9213-D49B97B74AE8";
    portalURL = "https://tcapi.simmersion.net";
    UMichPoolID = "E0CE9164-5DE4-487E-A5FA-32777755FA31";
  }
  else {
    PortalID = "7728DEAD-2980-4748-9213-D49B97B74AE8";
    portalURL = "https://tcapi.simmersionstage.net";
    UMichPoolID = "E0CE9164-5DE4-487E-A5FA-32777755FA31";
  }

  import bannerData from '../banner.json'; // adjust path as needed

  export default {
    name: 'Home',
    data() {
      return {
        email: null,
        errorMsg: null,
        orgcredential: null,
        pass: null,
        remember: null,
        bannerMessage: ''
      }
    },
    created() {
      this.bannerMessage = bannerData.message;
    },
    mounted() {
      // Autoforward to dashboard
      try {
        this.udata = JSON.parse(localStorage.getItem("udata"));
        // Check for expired session
        if (this.udata !== null && typeof (this.udata.SessionID) !== "undefined" && this.udata.expiry >= new Date().getTime()) {
          window.location = '/dashboard';
        }
      }
      catch (e) { }

      // Allow for external events to pass OAuth data back into the application
      Ext.Vue = this;

      // For OAuth
      this.$bus.$on("ExternalEvent", (ev, param) => {
        this.processExternalEvent(ev, param);
      });

      document.body.classList.add("login");
      try {
        this.email = localStorage.getItem("7728DEAD-2980-4748-9213-D49B97B74AE8_u");
        this.pass = localStorage.getItem("7728DEAD-2980-4748-9213-D49B97B74AE8_p");
      }
      catch (e) { }
    },
    methods: {
      checkKeyup(e) {
        if (e.key === "Enter") {
          this.doLoginForm();
        }
      },
      doLoginForm() {

        var element = document.getElementsByClassName("errorBox");
        element[0].classList.remove("yellowerrorBox");

        this.startLoading();
        var _email = this.email;
        this.doLogin(this.email, this.pass, this.remember).then(r => {
          this.endLoading();
          if (r === null || r === 0) {

            debugger;
            //this.errorMsg = "There was a problem logging in";

            if (_email.toUpperCase().indexOf("@UMICH.EDU") !== -1) {
              var self = this;
              this.startLoading();
              this.$http({
                method: 'get',
                async: false,
                url: portalURL + '/SSO.svc/GetClientByEmail?email=' + _email,
                //url: "http://localhost:62377/SSO.svc/GetClientByEmail?email=" + _email,
                headers: {
                  'Content-Type': 'application/xml'
                },

              }).then(function (response) {
                self.endLoading();
                if (response.status === 200) {

                  var isExist = false;

                  var xmlString = response.data.replace('<string xmlns="http://schemas.microsoft.com/2003/10/Serialization/">', '').replace('</string>', '');

                  if (xmlString != '') {
                    var resp = xmlString.split('|');
                    var h;
                    for (h = 0; h < resp.length; h++) {
                      if (resp[h].toUpperCase() == UMichPoolID.toUpperCase()) {
                        //self.errorMsg = "Warning! Your account can be converted to work with your organization's login. To update your account, please login using use my organization's login option. To continue using your SIMmersion account, click Login button.";
                        self.errorMsg = "You do not have a Training Center login.  However, you may have an account that can be accessed with your organization's login. Please try logging in using the use my organization's login option.";
                        var element = document.getElementsByClassName("errorBox");
                        element[0].classList.add("yellowerrorBox");
                        isExist = true;
                      }

                    }

                    if (!isExist) {
                      self.errorMsg = "There was a problem logging in";
                    }
                  }
                  else {
                    self.errorMsg = "You do not have a Training Center login.  However, you may have an account that can be accessed with your organization's login. Please try logging in using the use my organization's login option.";
                  }

                }
                else {
                  self.errorMsg = "There was a problem logging in";
                }

              });

            }
            else {
              this.errorMsg = "There was a problem logging in";
            }


          }
          else {
            if (r === 1) {
              this.errorMsg = "This account requires verification. Please check your email."
            }
            else if (r === 2) {
              this.errorMsg = "This account has been archived by SIMmersion. Please contact SIMmersion."
            }
            else if (r === 3) {
              this.errorMsg = "The account associated with this email address has been linked to an organization login account. Please log in using the <strong>“Use My Organization's Login”</strong> option.";

            }
            else if (r === 5) {


              if (_email.toUpperCase().indexOf("@UMICH.EDU") !== -1) {
                var self = this;
                this.startLoading();
                this.$http({
                  method: 'get',
                  async: false,
                  url: this.$hostname + '/SSO.svc/GetClientByEmail?email=' + _email,
                  //url: "http://localhost:62377/SSO.svc/GetClientByEmail?email=" + _email,
                  headers: {
                    'Content-Type': 'application/xml'
                  },

                }).then(function (response) {
                  self.endLoading();
                  if (response.status === 200) {

                    var isExist = false;

                    var xmlString = response.data.replace('<string xmlns="http://schemas.microsoft.com/2003/10/Serialization/">', '').replace('</string>', '');

                    if (xmlString != '') {
                      var resp = xmlString.split('|');
                      var h;
                      for (h = 0; h < resp.length; h++) {
                        if (resp[h].toUpperCase() == UMichPoolID.toUpperCase()) {
                          self.errorMsg = "Warning! Your account can be converted to work with your organization's login. To update your account, please login using use my organization's login option.";

                          var element = document.getElementsByClassName("errorBox");
                          element[0].classList.add("yellowerrorBox");
                          isExist = true;
                        }

                      }

                      if (!isExist) {
                        self.errorMsg = "There was a problem logging in";
                      }
                    }
                    else {
                      self.errorMsg = "Warning! Your account can be converted to work with your organization's login. To update your account, please login using use my organization's login option.";
                    }

                  }
                  else {
                    self.errorMsg = "There was a problem logging in";
                  }

                });

              }
              else {
                this.errorMsg = "There was a problem logging in";
              }

            }
            else {
              this.doPage().then(r => {
                if (!r) {
                  this.errorMsg = "This account does not have access to Admin Center";
                }
                else {

                  sessionStorage.setItem('isFirstLoad', true);
                  document.body.className = document.body.className.replace("login", "");

                  this.$router.push({ name: 'dashboard' });


                }

              });
            }
          }
        });
      },
      doOrgLogin() {
        this.$refs.orgModal.show();
      },
      doOrgLoginOK() {

        this.startLoading();
        var self = this;
        this.$http({
          method: 'get',
          url: this.$hostname + '/SSO.svc/Request?_e=' + this.orgcredential + "&_p=" + PortalID,
          headers: {
            'Content-Type': 'application/xml'
          },

        }).then(function (response) {
          self.endLoading();
          if (response.status === 200) {

            var xmlString = response.data.replace('<string xmlns="http://schemas.microsoft.com/2003/10/Serialization/">', '').replace('</string>', '');

            var resp = xmlString.split('|');

            if (resp[0] === "Failure") {
              self.errorMsg = "An error occurred. Please contact your administrator";
            }
            else if (resp[0] === "SAML") {

              if (resp[1].indexOf("suicidepreventionlifeline") != -1) { //Check user if lifeline user

                self.$http({
                  method: 'post',
                  url: self.$lifeline_user_validation_url + '&email=' + self.orgcredential,
                  async: false,
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },

                }).then(function (response2) {
                  if (response2 != null) {
                    if (response2.data.admin == "1" || response2.data.lmsadmin == "1" || response2.data.lmsreportmanager == "1") {
                      window.location = resp[1].replace(/&amp;/g, "&");
                    }
                    else {
                      self.errorMsg = "User does not have administrator privileges";
                    }
                  } else {
                    self.errorMsg = "Error occured while reading API data";
                  }
                });

              }
              else {
                window.location = resp[1].replace(/&amp;/g, "&");
              }
            }
            else if (resp[0] === "OAUTH") {
              localStorage.setItem("oauth_userinfo", resp[1]);
              window.open(resp[2].replace(/&amp;/g, "&"), "Authentication", "resizable,scrollbars,status,width=800,height=600");

            }

          }
          else {
            this.errorMsg = "A login error occurred. Please contact SIMmersion support";
          }
        });
      },
      processExternalEvent(ev, param) {
        if (ev === "doOAuth") {
          if (param !== null) {
            this.udata = param;
            this.udata.expiry = new Date().getTime() + 60 * 60 * 24 * 1000;
            localStorage.setItem("udata", JSON.stringify(this.udata));

            document.body.className = document.body.className.replace("login", "");

            this.$router.push({ name: 'dashboard' });
          }
          else {
            this.errorMsg = "Failed to Log In";
          }
        }
      }
    }
  }
</script>


